import {
  ActualOperation,
  DropdownObjectType,
  Task
} from '../../types/interfaces';

function toIsoOrUndefined(value: string | undefined): string | undefined {
  return value ? new Date(value).toISOString() : undefined;
}

export function buildTaskPayloadForSubmit(
  data: Task,
  plannedOperations: DropdownObjectType[],
  actualOperations: ActualOperation[]
): Task {
  const newData = { ...data };
  newData.plannedOperations = plannedOperations;
  newData.actualOperations = JSON.parse(
    JSON.stringify(actualOperations)
  )?.flatMap((x: ActualOperation) => {
    if (!x.operation || x.operation.label === '') return [];
    if (!(x.operation as any).id) {
      (x.operation as any).id = parseInt(x.operation.key.toString() ?? '0');
    }
    if (!x.operation.key) {
      x.operation.key = (x.operation as any).id.toString();
    }
    if (typeof x.id == 'string' && x.id.includes('-')) x.id = 0;
    delete x.measure;

    const normalizedVolume =
      !x.volume ||
      (typeof x.volume === 'string' && x.volume.trim() === '')
        ? null
        : x.volume;
    return {
      ...x,
      volume: normalizedVolume
    } as ActualOperation;
  });
  newData.priority =
    newData.priority === '' ? (undefined as unknown as string) : newData.priority;
  newData.actualStartDate = toIsoOrUndefined(
    newData.actualStartDate as string | undefined
  ) as Task['actualStartDate'];
  newData.actualEndDate = toIsoOrUndefined(
    newData.actualEndDate as string | undefined
  ) as Task['actualEndDate'];
  newData.plannedStartDate = toIsoOrUndefined(
    newData.plannedStartDate as string | undefined
  ) as Task['plannedStartDate'];
  newData.plannedEndDate = toIsoOrUndefined(
    newData.plannedEndDate as string | undefined
  ) as Task['plannedEndDate'];

  return newData;
}
